import { useAuth } from '../../../hooks/useAuth';
import { useSpace } from '../../../hooks/useSpace';
import { getConsultationRole, shouldShowOnboarding } from '../utils/shouldShowOnboarding';

/** The member's consultation role in the current space, and whether their first-run tour is still due. */
export function useOnboardingEligibility() {
  const { user } = useAuth();
  const { currentSpace, memberships, isSuperAdmin } = useSpace();
  const role = memberships.find((membership) => membership.space.slug === currentSpace?.slug)?.role;

  return {
    consultationRole: getConsultationRole(role, isSuperAdmin),
    isDue: shouldShowOnboarding({ user, role, isSuperAdmin }),
  };
}
